
    export const NewUserButtonStyles = {
        marginTop: (theme) => theme.spacing(2),
        marginBottom: (theme) => theme.spacing(2),
        marginLeft: (theme) => theme.spacing(1),
        marginRight: (theme) => theme.spacing(1)
    },
    EmployeeNameDropdownStyles = {
        marginTop: (theme) => theme.spacing(1),
        marginBottom: (theme) => theme.spacing(4)
    },
    PendingUserDropdownStyles = {
        marginTop: (theme) => theme.spacing(4)
    },
    ORStyles = {
        marginTop: (theme) => theme.spacing(5)
    }
